import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Search } from "lucide-react";

const CORPUS = [
  { title: "Solar Rooftop Scheme", url: "/services/solar_rooftop", tags: ["citizen","solar","subsidy"] },
  { title: "EV Charging Application", url: "/services/ev", tags: ["ev","subsidy"] },
  { title: "Compressed Biogas (CBG)", url: "/services/cbg", tags: ["cbg","industry"] },
  { title: "Net Metering Registration", url: "/services/net_metering", tags: ["metering","discom"] },
  { title: "File an RTI", url: "/rti", tags: ["rti","governance"] },
  { title: "Register a Grievance", url: "/grievance", tags: ["grievance"] },
  { title: "Track Application", url: "/track", tags: ["track"] },
  { title: "Projects Dashboard", url: "/projects", tags: ["projects","works"] },
  { title: "Punjab GIS Map", url: "/gis", tags: ["gis","map","projects"] },
  { title: "Tender Portal", url: "/tenders", tags: ["tenders","procurement"] },
  { title: "Downloads & Circulars", url: "/downloads", tags: ["downloads","policy"] },
];

export default function SearchPage() {
  const [sp] = useSearchParams();
  const q = (sp.get("q") || "").toLowerCase();
  const hits = CORPUS.filter((c) => (c.title + " " + c.tags.join(" ")).toLowerCase().includes(q));
  return (
    <div className="container-x py-12 max-w-3xl">
      <div className="flex items-center gap-2 text-muted-foreground"><Search className="h-4 w-4"/><span className="text-sm">Global search</span></div>
      <h1 className="mt-1 text-3xl font-heading font-bold">Results for “{q}”</h1>
      <div className="mt-6 space-y-2">
        {hits.length === 0 && <div className="text-sm text-muted-foreground">No matches. Try searching for “solar”, “tender” or “RTI”.</div>}
        {hits.map((h) => (
          <Link to={h.url} key={h.url} className="block rounded-xl border border-border bg-card p-4 hover:border-[hsl(var(--primary))]">
            <div className="font-heading font-semibold">{h.title}</div>
            <div className="text-xs text-muted-foreground mt-0.5">{h.url} · {h.tags.join(" · ")}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
